import { ChangeDetectionStrategy, Component, computed, input, type InputSignal, type Signal } from '@angular/core';
import { UiStickyActionBarAlign } from '../../types/ui-sticky-action-bar-align.type';

@Component({
  selector: 'ui-sticky-action-bar',
  imports: [],
  templateUrl: './ui-sticky-action-bar.component.html',
  styleUrl: './ui-sticky-action-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiStickyActionBarComponent {
  public readonly ariaLabel: InputSignal<string> = input<string>('Actions');
  public readonly align: InputSignal<UiStickyActionBarAlign> = input<UiStickyActionBarAlign>('stretch');
  public readonly elevated: InputSignal<boolean> = input<boolean>(true);

  protected readonly isStart: Signal<boolean> = computed((): boolean => this.align() === 'start');
  protected readonly isCenter: Signal<boolean> = computed((): boolean => this.align() === 'center');
  protected readonly isEnd: Signal<boolean> = computed((): boolean => this.align() === 'end');
  protected readonly isStretch: Signal<boolean> = computed((): boolean => this.align() === 'stretch');
}
